'use strict';

var _ = require('lodash');
function ConfigurationFlightTagService($filter, restangular, $http, fileSaveService, momentService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var flightTagRest = restangular.one('domain').all('flightTags');
  var fieldsToExport = ['flightTagName', 'carrierCode', 'flightNumber', 'legOrigin', 'legDestination', 'season', 'departureDateRangeStart', 'departureDateRangeEnd', 'departureDateDaysOfWeek', 'departureTimeRangeStart', 'departureTimeRangeEnd', 'createdAt', 'lastUpdatedAt'];
  var csvHeaders = ['FLIGHT CATEGORY NAME', 'AIRLINE CODE', 'FLIGHT NUMBER', 'LEG ORIGIN', 'LEG DESTINATION', 'SEASON', 'START DPTR DATE', 'END DPTR DATE', 'DAY OF WEEK', 'START DPTR TIME', 'END DPTR TIME', 'CREATED', 'UPDATED'];
  function deleteUnneededAttributes(newEntity) {
    delete newEntity._old;
    delete newEntity.originalRowId;
    delete newEntity._links;
  }
  function transformDates(row) {
    row.departureDateRangeStart = row.departureDateRangeStart ? row.departureDateRangeStart.toISOString() : undefined;
    row.departureDateRangeEnd = row.departureDateRangeEnd ? row.departureDateRangeEnd.toISOString() : undefined;
    row.createdAt = row.createdAt ? row.createdAt.toISOString() : null;
    row.lastUpdatedAt = row.lastUpdatedAt ? row.lastUpdatedAt.toISOString() : null;
  }
  function transformDateCsv(field, format) {
    return field ? rmMomentFormat(momentService.of(field.toISOString(), format), 'DATE_ISO') : undefined;
  }
  function transformDatesBeforeExportingToCsv(row) {
    row.departureDateRangeStart = transformDateCsv(row.departureDateRangeStart, momentService.FIELD.DEPARTURE_DATE);
    row.departureDateRangeEnd = transformDateCsv(row.departureDateRangeEnd, momentService.FIELD.DEPARTURE_DATE);
    row.createdAt = transformDateCsv(row.createdAt, momentService.FIELD.CREATED_AT);
    row.lastUpdatedAt = transformDateCsv(row.lastUpdatedAt, momentService.FIELD.CREATED_AT);
  }
  function transformFlightSeasons(row) {
    row.season = row.season ? _.split(row.season, ',').map(String) : undefined;
  }
  function transformFlightNumbers(row) {
    row.flightNumber = row.flightNumber ? _.split(row.flightNumber, ',').map(Number) : undefined;
  }
  function transformDaysOfWeek(row) {
    row.departureDateDaysOfWeek = row.departureDateDaysOfWeek ? _.split(row.departureDateDaysOfWeek, ',') : undefined;
  }
  function transformLegOriginAndLegDestination(row) {
    row.legOrigin = row.legOrigin && row.legOrigin !== '' ? row.legOrigin : undefined;
    row.legDestination = row.legDestination && row.legDestination !== '' ? row.legDestination : undefined;
  }
  function transformTime(row) {
    row.departureTimeRangeStart = row.departureTimeRangeStart ? row.departureTimeRangeStart.toISOString().replace(':', '') : null;
    row.departureTimeRangeEnd = row.departureTimeRangeEnd ? row.departureTimeRangeEnd.toISOString().replace(':', '') : null;
  }
  function transformTimeBeforeExportingToCsv(row) {
    row.departureTimeRangeStart = row.departureTimeRangeStart ? row.departureTimeRangeStart.toISOString() : null;
    row.departureTimeRangeEnd = row.departureTimeRangeEnd ? row.departureTimeRangeEnd.toISOString() : null;
  }
  function save(rowsToSave) {
    var payloadEntity = _.transform(rowsToSave, function (result, row) {
      var clonedRow = _.clone(row);
      deleteUnneededAttributes(clonedRow);
      transformDates(clonedRow);
      transformFlightSeasons(clonedRow);
      transformFlightNumbers(clonedRow);
      transformDaysOfWeek(clonedRow);
      transformLegOriginAndLegDestination(clonedRow);
      transformTime(clonedRow);
      result.push(clonedRow);
    });
    return flightTagRest.customPUT(payloadEntity);
  }
  function remove(rowsToRemove) {
    _.forEach(rowsToRemove, function (row) {
      delete row.uid;
      deleteUnneededAttributes(row);
      transformFlightSeasons(row);
      transformFlightNumbers(row);
      transformDaysOfWeek(row);
      transformLegOriginAndLegDestination(row);
      transformDates(row);
      transformTime(row);
    });
    return $http({
      method: 'DELETE',
      url: flightTagRest.getRestangularUrl(),
      data: rowsToRemove,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  function formatAsCsvRow(stringArrayToFormat) {
    var rowValues = _.chain(stringArrayToFormat).map(function (value) {
      if (value) {
        return '"' + value + '"';
      } else {
        return '';
      }
    }).toString().value();
    return rowValues + '\r\n';
  }
  function createCsvHeader(csvHeaders) {
    return formatAsCsvRow(csvHeaders);
  }
  function createCsvRow(row, fieldsToExport) {
    var valuesToExport = [];
    _.each(fieldsToExport, function (fieldName) {
      valuesToExport.push(row[fieldName]);
    });
    return formatAsCsvRow(valuesToExport);
  }
  function exportToCsv(data) {
    var fileData = createCsvHeader(csvHeaders);
    fileData = _.reduce(data, function (result, row) {
      var clonedRow = _.clone(row);
      transformDatesBeforeExportingToCsv(clonedRow);
      transformTimeBeforeExportingToCsv(clonedRow);
      result += createCsvRow(clonedRow, fieldsToExport);
      return result;
    }, fileData);
    fileSaveService.createFile(fileData, 'text/csv', 'FlightCategory.csv');
  }
  return {
    save: save,
    remove: remove,
    exportToCsv: exportToCsv
  };
}
ConfigurationFlightTagService.$inject = ['$filter', 'Restangular', '$http', 'FileSaveService', 'MomentService'];
module.exports = ConfigurationFlightTagService;